<template>
  <div class="custom-page-box">
    <a-card title="订购记录" :bordered="false" :headStyle="{fontSize:'18px'}">
      <custom-page-table
        ref="table"
        rowKey="orderId"
        :columns="columns"
        :queryParams="queryParams"
        :requestPromise="loadPromise"
      >
      </custom-page-table>
    </a-card>
  </div>
</template>
<script>
export default {
  name: 'OrderRecord',
  data() {
    return {
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      columns: [
        {
          title: '订单时间',
          dataIndex: 'orderTime'
        },
        {
          title: '订单编号',
          dataIndex: 'orderId'
        },
        {
          title: '应用名称',
          dataIndex: 'orderName'
        },
        {
          title: '订购版本',
          dataIndex: 'orderVersion'
        },

        {
          title: '订购周期',
          dataIndex: 'orderCycle'
        },
        {
          title: '支付金额(元)',
          dataIndex: 'orderPrice'
        }
      ],
      loadPromise: (params) => this.getMyRecordListPromise(params)
    }
  },
  mounted() {

  },
  methods: {
    getMyRecordListPromise(params) {
      this.getLogUtils().logWithTag('====params======', params)
      return this.getHttpServices().getServerApiService().post('service/selectOrderRecordList', params)
    }
  }
}
</script>
<style lang="less">
@import "../CustomPage";
</style>